import { VISIBILITY_ANNOTATION_ACTION } from '../../../../common/constant/constant';
import type { ToggleVisibilityLabelPayloadT } from '../../../../common/side-panel/analytics/types';
import useAnalyticsForSidePanel from '../../../../common/side-panel/analytics/useAnalyticsForSidePanel';
import type { StoreTypeT } from '../../../../common/types/types';
import type { HeaderInfoT } from '../../annotations/types';
import { SIDE_PANEL_ACTIONS } from '../../const';
import { useDispatch } from '../../hooks/use-dispatch';
type PropsT = {
  headerInfo: HeaderInfoT;
  storeType: StoreTypeT;
  label: string;
};
export function useShowHideHandler({
  headerInfo,
  storeType,
  label
}: PropsT) {
  const dispatch = useDispatch();
  const {
    sendEventForToggleVisibilityLabel
  } = useAnalyticsForSidePanel();
  const handleShowHideAnnotation = () => {
    const {
      isVisible
    } = headerInfo;
    dispatch({
      type: SIDE_PANEL_ACTIONS.SHOW_HIDE_ANNOTATIONS,
      annotationLabel: label,
      hidden: isVisible,
      allAnnotations: true,
      storeType
    });
    const eventPayload: ToggleVisibilityLabelPayloadT = {
      label: label,
      action: !isVisible ? VISIBILITY_ANNOTATION_ACTION.SHOW : VISIBILITY_ANNOTATION_ACTION.HIDE
    };
    sendEventForToggleVisibilityLabel(eventPayload);
  };
  return {
    handleShowHideAnnotation
  };
}